/** Legal documents shown on public pages and Settings → Legal. */

export const LEGAL_CONTACT_EMAIL = "squares@terrakronos.com";

export const LEGAL_DOCUMENTS = [
  {
    id: "privacy",
    title: "Privacy Policy",
    path: "/privacy",
    lastUpdated: "September 12, 2026",
    description: "What we collect, how we use it, and your choices.",
  },
  {
    id: "terms",
    title: "Terms of Service",
    path: "/terms",
    lastUpdated: "September 12, 2026",
    description: "The rules for using TerraKronos.",
  },
];

export function legalDocumentById(id) {
  return LEGAL_DOCUMENTS.find((doc) => doc.id === id) || null;
}

export function settingsTabFromSearch(search) {
  const raw =
    typeof search === "string"
      ? new URLSearchParams(search).get("tab")
      : search?.get?.("tab");
  if (raw === "subscription") return "subscription";
  if (raw === "appearance") return "appearance";
  if (raw === "notifications") return "notifications";
  if (raw === "professional" || raw === "library") return "professional";
  if (raw === "people") return "team";
  if (raw === "team" || raw === "organization" || raw === "office") return "organization";
  if (raw === "usage") return "usage";
  if (raw === "legal") return "legal";
  return null;
}
